import { List } from './styles';
import { Link } from 'react-router-dom';

import menu1 from '../../assets/AlterarBanner.svg';
import menu2 from '../../assets/Listar.svg';


export function MenuGastronomia(){
  return (
    <>
      <List>
        <Link to="/alimentacao-banner">
          <img src={menu1} alt="Alterar Banner" />
          <p>Alterar Banner</p>
        </Link>
      </List>
      <List>
        <Link to="/lista-de-restaurantes">
          <img src={menu2} alt="Lista de Restaurantes" />
          <p>Lista de Restaurantes</p>
        </Link>
      </List>
    </>
    
  );
}